module.exports = __webpack_public_path__ + "img/english-study-lestening.96af3767.svg";